import { useContext, useEffect, useState } from 'react'
import { MitoContext } from '../context/MitoContext'

export type ContentType = 'text' | 'image' | 'file'

export function useMitoContent({ contentId, type, defaultValue }: { 
  contentId: string; 
  type: ContentType; 
  defaultValue: string }) {

  const ctx = useContext(MitoContext)
  if (!ctx) {
    throw new Error('useMitoContent must be used within a MitoProvider')
  }
  const [value, setValue] = useState<string>(() => ctx.getValue(contentId) ?? defaultValue)

  useEffect(() => {
    ctx.register(contentId)
    const unsubscribe = ctx.subscribe(contentId, (next) => setValue((next ?? defaultValue)))
    return () => { unsubscribe && unsubscribe() }
  }, [contentId, defaultValue, type, ctx])

  return value
  
}
